



















import { Component, Mixins } from 'vue-property-decorator'

import TextareaCounter from '../../../TextareaCounter/TextareaCounter.vue'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput, InputFieldEmits } from '../../mixins'
import { TextareaInputProps } from './types'

@Component({
  components: {
    FieldWrapper,
    TextareaCounter,
  },
})
export default class TextareaInput extends Mixins(BaseInput, InputFieldEmits) {
  get settings(): TextareaInputProps {
    return this.getSettings<TextareaInputProps>()
  }

  get counter(): number | undefined {
    return this.settings.counter
  }
}
